document.addEventListener('DOMContentLoaded', function () {  
  if (window.innerWidth > 1140) {
    setTimeout(() => {
      const grid = document.querySelector('.mega-menu-1__grid');

      document.querySelectorAll('.collection-card-v2').forEach(card => {      
        card.addEventListener('mouseenter', function () {                    

          // remove all active
          document.querySelectorAll('.active').forEach(el => {
            el.classList.remove('active');
          });

          // remove old width classes (important)
          if (grid) {
            grid.classList.remove('article-width', 'productlist-width');
          }

          const title = this.getAttribute('data-collection-title');    
          const target = document.getElementById(title);

          if (target) {
            target.classList.add('active');
          }

          document.querySelectorAll('.nav_article_wrap').forEach(item => {
            const intro = item.getAttribute('data-collection-introducing');

            if (intro === title) {
              item.classList.add('active');

              // 👇 NEW: get data-content-width and add to grid
              const contentWidth = item.getAttribute('data-content-width');

              if (grid && contentWidth) {
                grid.classList.add(contentWidth);
              }
            }
          });
        });
      });
    }, 1500);  
  }
});


document.addEventListener('click', function (e) {

  const item = e.target.closest(
    '.xo-menu-hamburger__content .mega-menu-1__mobile .collection-card-v2[data-collection-title]'
  );

  if (!item) return;

  const key = item.getAttribute('data-collection-title');

  const current = document.querySelector(
    `.xo-menu-hamburger__content .mega-menu-1__mobile .collapse_content[data-collapse="${key}"]`
  );

  if (!current) return;

  const isActive = current.classList.contains('active');

  // Badha content close
  document.querySelectorAll(
    '.xo-menu-hamburger__content .mega-menu-1__mobile .collapse_content[data-collapse]'
  ).forEach(el => {
    el.classList.remove('active');
  });

  // Badha items mathi active remove
  document.querySelectorAll(
    '.xo-menu-hamburger__content .mega-menu-1__mobile .collection-card-v2'
  ).forEach(el => {
    el.classList.remove('active');
  });

  // Toggle behavior
  if (isActive) return;

  // Active add karo (banne jagyae)
  current.classList.add('active');
  item.classList.add('active');

});




document.addEventListener("DOMContentLoaded", function () {

  function setBundleTitleHeight() {
    const titles = document.querySelectorAll(
      '.bundle-popup xo-product .xo-product-card--boxed.xo-product-card--radius .xo-product-card__information .xo-product-card__title'
    );

    let maxHeight = 0;

    titles.forEach((title) => {
      title.style.height = 'auto';
    });

    titles.forEach((title) => {
      const height = title.getBoundingClientRect().height;

      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    titles.forEach((title) => {
      title.style.height = maxHeight + 'px';
    });
  }

  const bundlePopup = document.getElementById('bundlePopup');
  const bundleTitle = document.getElementById('bundle_title');

  function openBundlePopup() {
    if (!bundlePopup) return;

    bundlePopup.classList.add('active');

    setTimeout(() => {
      setBundleTitleHeight();
    }, 100);
  }

  // Click par open
  bundleTitle?.addEventListener('click', openBundlePopup);

  // Page load pachi 5 second ma open (fakt #bundle_title hoy to j)
  window.addEventListener('load', () => {
    if (bundleTitle) {
      setTimeout(() => {
        openBundlePopup();
      }, 5000);
    }
  });

  // Close button
  document.querySelector('.bundle-close')?.addEventListener('click', () => {
    bundlePopup?.classList.remove('active');
  });

  // Overlay click close
  bundlePopup?.addEventListener('click', function (e) {
    if (e.target === this) {
      this.classList.remove('active');
    }
  });

});




document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".supported_items ul li");

  const svgIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> 
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8306 2.26496C11.5704 1.91148 12.4306 1.91138 13.1704 2.26496C13.4903 2.41786 13.7959 2.67913 14.4077 3.20051C14.6511 3.40797 14.7729 3.51181 14.9028 3.59895C15.2009 3.79875 15.5361 3.93764 15.8882 4.00715C16.0417 4.03746 16.2013 4.05007 16.52 4.07551C17.3212 4.13944 17.7219 4.17138 18.0562 4.28938C18.8294 4.56248 19.4383 5.17047 19.7114 5.94367C19.8294 6.2779 19.8613 6.67872 19.9253 7.47981C19.9507 7.79876 19.9634 7.95903 19.9937 8.11262C20.0632 8.46452 20.2022 8.79903 20.4019 9.097C20.489 9.22702 20.5928 9.34864 20.8003 9.59211C21.3218 10.204 21.582 10.5105 21.7349 10.8304C22.0884 11.5703 22.0885 12.4304 21.7349 13.1702C21.582 13.49 21.3215 13.796 20.8003 14.4075C20.593 14.6508 20.4889 14.7728 20.4019 14.9027C20.2021 15.2008 20.0632 15.5359 19.9937 15.888C19.9634 16.0416 19.9507 16.2011 19.9253 16.5198C19.8613 17.3208 19.8293 17.7218 19.7114 18.056C19.4383 18.8292 18.8294 19.4382 18.0562 19.7113C17.722 19.8291 17.321 19.8611 16.52 19.9251C16.2012 19.9505 16.0418 19.9632 15.8882 19.9935C15.5361 20.063 15.2009 20.2019 14.9028 20.4017C14.773 20.4887 14.651 20.5928 14.4077 20.8001C13.7962 21.3213 13.4902 21.5818 13.1704 21.7347C12.4306 22.0883 11.5704 22.0882 10.8306 21.7347C10.5107 21.5818 10.2042 21.3216 9.5923 20.8001C9.34882 20.5927 9.2272 20.4888 9.09718 20.4017C8.79921 20.202 8.4647 20.063 8.1128 19.9935C7.95921 19.9632 7.79894 19.9505 7.47999 19.9251C6.67885 19.8611 6.2781 19.8292 5.94386 19.7113C5.17066 19.4382 4.56266 18.8292 4.28956 18.056C4.17157 17.7217 4.13962 17.321 4.07569 16.5198C4.05026 16.2011 4.03764 16.0416 4.00733 15.888C3.93782 15.5359 3.79893 15.2008 3.59913 14.9027C3.512 14.7727 3.4081 14.6509 3.20069 14.4075C2.67931 13.7957 2.41804 13.4901 2.26515 13.1702C1.91157 12.4304 1.91167 11.5702 2.26515 10.8304C2.41803 10.5105 2.67925 10.204 3.20069 9.59211C3.40807 9.34878 3.512 9.22699 3.59913 9.097C3.7988 8.79904 3.93781 8.46449 4.00733 8.11262C4.03766 7.95903 4.05024 7.79876 4.07569 7.47981C4.13963 6.67865 4.1715 6.27792 4.28956 5.94367C4.56267 5.17056 5.17075 4.56248 5.94386 4.28938C6.2781 4.17131 6.67884 4.13944 7.47999 4.07551C7.79894 4.05006 7.95921 4.03748 8.1128 4.00715C8.46467 3.93763 8.79922 3.79862 9.09718 3.59895C9.22717 3.51182 9.34896 3.40788 9.5923 3.20051C10.2042 2.67907 10.5107 2.41784 10.8306 2.26496ZM16.3735 8.71223C16.0556 8.39443 15.5409 8.3944 15.2232 8.71223L10.3726 13.5618L8.77784 11.9671C8.46 11.6494 7.94427 11.6493 7.62648 11.9671C7.30882 12.285 7.30881 12.8007 7.62648 13.1185L9.79737 15.2884C10.1152 15.6062 10.63 15.6061 10.9478 15.2884L16.3735 9.86262C16.6913 9.54479 16.6913 9.03006 16.3735 8.71223Z" fill="#3F2D21"/> 
  </svg>`;

  listItems.forEach(li => {
    li.insertAdjacentHTML("afterbegin", svgIcon);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".unupported_items ul li");

  const svgIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10.8296 2.26521C11.5694 1.91163 12.4296 1.91172 13.1694 2.26521C13.4893 2.41809 13.7959 2.67841 14.4077 3.19978C14.6512 3.40732 14.7728 3.51204 14.9028 3.5992C15.2009 3.79891 15.5362 3.93693 15.8882 4.00642C16.0417 4.03671 16.2013 4.04935 16.52 4.07478C17.3213 4.13872 17.7219 4.17156 18.0562 4.28963C18.8293 4.56274 19.4374 5.17075 19.7105 5.94392C19.8284 6.27817 19.8603 6.67885 19.9243 7.48006C19.9497 7.79894 19.9634 7.95833 19.9937 8.11189C20.0632 8.46396 20.2011 8.79915 20.4009 9.09724C20.488 9.22727 20.5919 9.34893 20.7993 9.59236C21.3207 10.2041 21.582 10.5099 21.7349 10.8297C22.0884 11.5694 22.0883 12.4297 21.7349 13.1695C21.582 13.4894 21.3208 13.7959 20.7993 14.4078C20.592 14.6511 20.488 14.773 20.4009 14.9029C20.2012 15.201 20.0632 15.5362 19.9937 15.8883C19.9634 16.0418 19.9497 16.2014 19.9243 16.5201C19.8603 17.3213 19.8285 17.7219 19.7105 18.0562C19.4374 18.8294 18.8293 19.4374 18.0562 19.7105C17.7219 19.8285 17.3212 19.8604 16.52 19.9244C16.2013 19.9498 16.0417 19.9635 15.8882 19.9937C15.5362 20.0632 15.2009 20.2012 14.9028 20.401C14.7729 20.488 14.6511 20.592 14.4077 20.7994C13.7958 21.3209 13.4893 21.582 13.1694 21.7349C12.4296 22.0884 11.5694 22.0885 10.8296 21.7349C10.5098 21.582 10.204 21.3207 9.5923 20.7994C9.34887 20.592 9.22721 20.488 9.09718 20.401C8.79909 20.2012 8.4639 20.0632 8.11183 19.9937C7.95828 19.9634 7.79885 19.9498 7.47999 19.9244C6.67877 19.8604 6.27812 19.8285 5.94386 19.7105C5.17069 19.4374 4.56268 18.8294 4.28957 18.0562C4.17149 17.722 4.13866 17.3214 4.07472 16.5201C4.04929 16.2014 4.03665 16.0418 4.00636 15.8883C3.93687 15.5363 3.79885 15.2009 3.59914 14.9029C3.51199 14.7729 3.40721 14.6513 3.19972 14.4078C2.67834 13.796 2.41803 13.4894 2.26515 13.1695C1.91166 12.4297 1.91157 11.5695 2.26515 10.8297C2.41803 10.5099 2.6786 10.2039 3.19972 9.59236C3.40725 9.34884 3.51198 9.22728 3.59914 9.09724C3.79891 8.79916 3.93686 8.46393 4.00636 8.11189C4.03667 7.95835 4.04928 7.79889 4.07472 7.48006C4.13867 6.67874 4.17151 6.2782 4.28957 5.94392C4.56267 5.17072 5.17066 4.56273 5.94386 4.28963C6.27814 4.17157 6.67868 4.13873 7.47999 4.07478C7.79884 4.04934 7.95828 4.03673 8.11183 4.00642C8.46387 3.93692 8.7991 3.79897 9.09718 3.5992C9.22718 3.51206 9.34895 3.40814 9.5923 3.20076C10.204 2.67951 10.5098 2.41811 10.8296 2.26521ZM16.061 7.31795C15.8962 7.31796 15.7381 7.38402 15.6216 7.50056L12.0005 11.1217L8.37843 7.50056C8.26189 7.38403 8.10379 7.31796 7.93898 7.31795C7.77427 7.31801 7.61601 7.38408 7.49953 7.50056C7.38315 7.61708 7.31788 7.77533 7.31789 7.94002C7.31796 8.10475 7.38304 8.26298 7.49953 8.37947L11.1216 12.0006L7.5005 15.6217C7.38409 15.7382 7.31886 15.8964 7.31886 16.0611C7.31898 16.2256 7.38421 16.3832 7.5005 16.4996C7.61705 16.6161 7.77515 16.6822 7.93996 16.6822C8.10471 16.6823 8.26289 16.617 8.37941 16.5006L12.0005 12.8795L15.6206 16.5006C15.7371 16.617 15.8954 16.6822 16.0601 16.6822C16.2249 16.6822 16.383 16.6161 16.4995 16.4996C16.6158 16.3832 16.681 16.2257 16.6812 16.0611C16.6812 15.8964 16.616 15.7382 16.4995 15.6217L12.8794 12.0006L16.5005 8.37947C16.617 8.26299 16.6821 8.10479 16.6821 7.94002C16.6821 7.77532 16.6169 7.61709 16.5005 7.50056C16.384 7.38407 16.2258 7.318 16.061 7.31795Z" fill="#D4D4D4"/>
  </svg>`;

  listItems.forEach(li => {
    if (!li.querySelector("svg")) { // 🔥 avoid duplicate
      li.insertAdjacentHTML("afterbegin", svgIcon);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const panes = document.querySelectorAll(".tab-pane");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const id = this.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      panes.forEach(p => p.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(id).classList.add("active");
    });
  });
});



(function() {
  function init() {
    var header = document.querySelector('.xo-header');
    if (!header) return;

    var sticky = header.querySelector('xo-sticky');
    var items = header.querySelectorAll('.xo-header__desktop .xo-menu-horizontal .xo-menu-horizontal__item');

    if (!sticky || !items.length) return;

    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        sticky.setAttribute('xo-is-sticky', '');
      });
      item.addEventListener('mouseleave', function() {
        sticky.removeAttribute('xo-is-sticky');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.querySelectorAll('.tab_btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const tab = this.dataset.tab;

    document.querySelectorAll('.tab_btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(tab).classList.add('active');
  });
});


document.addEventListener('click', function (e) {
  const prescriptionLink = e.target.closest('a[href="#prescriptions"]');
  if (prescriptionLink) {
    e.preventDefault();
    const tabBtn = document.querySelector('.tab-btn[data-tab="prescriptions"]');
    if (tabBtn) {
      tabBtn.click();
      const section = document.querySelector('.section-product-tabs');
      if (section) {
        const offset = 100; // Adjust for sticky header
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = section.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }
});


function equalHeightLocalLists() {
  const items = document.querySelectorAll(
    '.local-lists-content .local-lists-inn[data-tab-link="link-international"] .local-lists-grid'
  );

  if (!items.length) return;

  let maxHeight = 0;

  // Reset height
  items.forEach((item) => {
    item.style.height = 'auto';
  });

  // Get max height
  items.forEach((item) => {
    maxHeight = Math.max(maxHeight, item.offsetHeight);
  });

  // Apply same height
  items.forEach((item) => {
    item.style.height = maxHeight + 'px';
  });
}

// Initial load
window.addEventListener('load', () => {
  equalHeightLocalLists();

  // Run again after small delay
  setTimeout(equalHeightLocalLists, 500);
});

// Resize
window.addEventListener('resize', equalHeightLocalLists);

// Observe dynamic changes
const target = document.querySelector(
  '.local-lists-content .local-lists-inn[data-tab-link="link-international"]'
);

if (target) {
  const observer = new MutationObserver(() => {
    equalHeightLocalLists();
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}
